module.exports = __webpack_public_path__ + "static/media/DP.fca08b09.png";